import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ZlatiArhivPage } from './pages/ZlatiArhivPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/zlati-arhiv" element={<ZlatiArhivPage data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}